<template>
  <div id="bscpage1-view">
    <dv-full-screen-container>
      <div class="block-top-header">
        <div style="width: 40%">
          <top-header
            name="topHeader"
            :PageTitle="PageTitle"
            ActiveMenuIndex="bscpage1"
          />
        </div>
        <div style="width: 60%">
          <el-cascader
            id="selectedMonth"
            style="font-size: 22px; width: 350px"
            v-model="selectedMonth"
            :options="optionsmonth"
            :props="propsMonth"
            collapse-tags
            @change="
              changeSelectComponent('selectedMonth');
              refreshDataOnChange();
            "
          ></el-cascader>

          <el-select
            v-model="selectedArea"
            style="right: -100px"
            class="block-top-button-field"
            placeholder
            @change="refreshDataOnChange()"
          >
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="selectedBU"
            style="right: -150px"
            class="block-top-button-field"
            placeholder="所有BU"
            @change="refreshDataOnChange()"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="block-top-line"></div>

      <div class="main-content">
        <div class="block-top-bottom-content">
          <div class="block-top-mid">
            <bscbing1 ref="bscbing1Component"></bscbing1>
            <bscbo1 ref="bscbo1Component"></bscbo1>
            <bscdown ref="bscdownComponent"></bscdown>
          </div>
          <div class="block-top-content">
            <div class="block-top-content-1">
              <bsczhu1 ref="bsczhu1Component" />
              <bsczhu2 ref="bsczhu2Component" />
              <!-- <bscdown1></bscdown1> -->
            </div>
            <div class="block-top-content-2">
              <bscdown2 ref="bscdown2Component"></bscdown2>
            </div>
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import topHeader from "../TopMenu/topHeader.vue";
import bscbing1 from "./bscbing1";
import bscbo1 from "./bscbo1";
import bsczhu1 from "./bsczhu1";
import bsczhu2 from "./bsczhu2";
import bscdown from "./bscdown";
// import bscdown1 from "./bscdown1";
import bscdown2 from "./bscdown2";
import request from "@/utils/request";
import { AREA_LIST, BU_LIST, MONTH_NAME } from "../mainPage/area_bu";

export default {
  name: "bscpage1",
  components: {
    topHeader,
    bscbing1,
    bscbo1,
    bsczhu1,
    bscdown,
    // bscdown1,
    bscdown2,
    bsczhu2,
  },
  data() {
    return {
      PageTitle: this.locale("Health of BU", "BU健康度"),
      options: BU_LIST,
      options2: AREA_LIST,
      valuemonth: "",
      optionsmonth: [
        { value: "1", label: "1月" },
        { value: "2", label: "2月" },
        { value: "3", label: "3月" },
        { value: "4", label: "4月" },
        { value: "5", label: "5月" },
        { value: "6", label: "6月" },
        { value: "7", label: "7月" },
        { value: "8", label: "8月" },
        { value: "9", label: "9月" },
        { value: "10", label: "10月" },
        { value: "11", label: "11月" },
        { value: "12", label: "12月" },
        { value: "", label: "全年" },
      ],
      selectedBU: "",
      strTime: [],
      selectedMonth: [],
      selectedArea: "SH",
      selectedYear: "2020",
      propsMonth: { multiple: true },
      optionsYear: [
        { value: "2019", label: "2019" },
        { value: "2020", label: "2020" },
      ],
    };
  },
  created() {
    this.optionsmonth = [];
    const iNowYear = new Date().getFullYear();
    for (let i = iNowYear; i > iNowYear - 5; i--) {
      let itemYear = {
        label: i,
        value: i,
        children: [],
      };
      for (let m = 1; m <= 12; m++) {
        let itemMonth = {
          label: MONTH_NAME[m - 1].label,
          value: i + "-" + m,
        };
        itemYear.children.push(itemMonth);
      }
      this.optionsmonth.push(itemYear);
    }
    this.selectedArea = this.options2[1].value;
  },
  mounted() {
    const { GataTimeByData, refreshDataOnChange, changeSelectComponent } = this;
    this.optionsYear = [];
    this.GataTimeByData();
    const curYear = new Date().getFullYear();
    for (let i = 0; i <= 5; i++) {
      const valYear = curYear - i;
      this.optionsYear.push({ value: valYear, label: valYear });
    }

    var d = new Date();
    //this.selectedMonth = [[d.getFullYear(), d.getFullYear()+'-'+(d.getMonth()+1)]]
    console.log("输出3", this.strTime);
    var vData = this.strTime;
    var stYear = vData.Year;
    var stMonth = vData.Month;
    console.log("stYear", stYear);
    console.log("stMonth", stMonth);

    // this.selectedMonth =  [[Number(vData.Year) ,vData.Year+'-'+vData.Month]]
    // this.selectedMonth = [[2020, "2020-12"]];
  //  this.selectedMonth = [[2020, "2020-12"]];
    // changeSelectComponent("selectedMonth");

    // refreshDataOnChange();
    // this.timer = setInterval(this.refreshDataOnChange, 1000 * 60)
  },
  methods: {
    GataTimeByData() {
      var par = {};
      //var strTime;
      request({
        url: "EnergySaving/GataTimeByData",
        method: "post",
        data: par,
      }).then((response) => {
        var vData = {};
        vData = response.data;
        console.log("输出1", vData);
        //this.strTime = [[Number(vData.Year) ,vData.Year+'-'+vData.Month]]
        this.strTime = vData.Year;
        this.strMonth = vData.Month;
        console.log("输出2", this.strTime, this.strTime, this.strMonth);
         this.selectedMonth =  [[Number(vData.Year) ,vData.Year+'-'+vData.Month]]
        this.changeSelectComponent("selectedMonth");
        this.refreshDataOnChange();
      });
    },

    refreshDataOnChange() {
      let selBu = "";
      if (this.selectedBU !== undefined && this.selectedBU !== "") {
        //selBu = this.selectedBU.join()
        selBu = this.selectedBU;
      }
      const queryArgs = { QueryAreaName: this.selectedArea, QueryBU: selBu };
      if (selBu !== "") {
        queryArgs.QueryGroupBy = "Plant";
      }
      if (this.selectedMonth.length > 0) {
        queryArgs.QueryYear = this.selectedMonth[0][0];
        let monthList = "";
        for (let i = 0; i < this.selectedMonth.length; i++) {
          monthList += this.selectedMonth[i][1].split("-")[1] + ",";
        }
        if (monthList.length > 0) {
          monthList = monthList.substring(0, monthList.length - 1);
        }
        queryArgs.QueryStartMonth = monthList;
      } else {
        return;
      }

      request({
        url: "EnergySaving/GataData",
        method: "post",
        data: queryArgs,
      }).then((response) => {
        var vData = {};
        vData = response.data.items;
        console.log(vData);
        this.$refs.bsczhu2Component.refreshChart(vData);
      });

      request({
        url: "Kanban/ProductionValueInfo",
        method: "post",
        data: queryArgs,
      }).then((response) => {
        const res = response;
        console.log(res);
        var vData = {};
        if (
          res.data.Data !== undefined &&
          res.data.Data.ProductionInfo !== undefined &&
          res.data.Data.ProductionInfo !== null
        ) {
          vData = res.data.Data.ProductionInfo["42"];
        }
        this.$refs.bscbing1Component.refreshChart(vData);

        vData = {};
        if (
          res.data.Data !== undefined &&
          res.data.Data.ProductionInfo !== undefined &&
          res.data.Data.ProductionInfo !== null
        ) {
          vData = res.data.Data.ProductionInfo["41"];
        }
        this.$refs.bscbo1Component.refreshChart(vData);

        vData = {};
        if (
          res.data.Data !== undefined &&
          res.data.Data.ProductionInfo !== undefined &&
          res.data.Data.ProductionInfo !== null
        ) {
          vData = res.data.Data.ProductionInfo["43"];
        }
        this.$refs.bscdownComponent.refreshChart(vData);

        vData = {};
        if (
          res.data.Data !== undefined &&
          res.data.Data.ProductionInfo !== undefined &&
          res.data.Data.ProductionInfo !== null
        ) {
          vData = res.data.Data.ProductionInfo["42"];
        }
        this.$refs.bsczhu1Component.refreshChart(vData);

        vData = res.data.Data.PlantHealth;
        this.$refs.bscdown2Component.refreshChart(vData);

        /*
        vData = undefined
        if (res.data.Data.ProductionInfo['41'] !== undefined) {
          vData = res.data.Data.ProductionInfo['41']
        }
        this.$refs.bsczhu2Component.refreshChart(vData)
        */
      });
    },
    changeSelectComponent(id) {
      var obj = document.querySelector("#" + id + " .el-cascader__tags");
      if (obj == null) {
        return;
      }
      let monthList = "";
      let prevYear = "";
      for (let i = 0; i < this.selectedMonth.length; i++) {
        let item = this.selectedMonth[i];
        if (prevYear == "") {
          prevYear = item[0];
          monthList = item[0] + " / ";
        }
        if (prevYear != item[0]) {
          this.$message.error("不允许选择跨年！");
          return;
        }
        monthList += item[1].split("-")[1] + ",";
      }
      if (monthList.length > 4) {
        monthList = monthList.substring(0, monthList.length - 1);
      }
      document.querySelector(
        "#" + id + " .el-cascader__tags"
      ).innerHTML = monthList;
    },
  },
};
</script>

<style lang="less">
#bscpage1-view {
  width: 100%;
  height: 100%;
  background-color: #1b2445;
  color: #fff;

  #dv-full-screen-container {
    //background-image: url("./img/bg.png");
    background-image: url();
    background-color: #17293d;
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }
  .block-top-header {
    width: 100%;
    display: flex;
    background-color: #1b2445;
  }
  .block-top-line {
    //background-color: #1D2647;
    background-color: #313c5e;
    width: 100%;
    height: 4px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
  }
  .block-top-button-content {
    flex: 1;
    height: 3%;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-button-field {
    background-color: #1b2445;
    margin-top: 15px;
    margin-left: 10px;
  }
  .block-top-button-field /deep/ .el-input__inner {
    background-color: #1b2445;
    color: #fff !important;
    font-size: 22px;
  }
  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-mid {
    height: 35%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content {
    height: 60%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content-1 {
    height: 100%;
    width: 60%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 0px;
  }
  .block-top-content-2 {
    height: 100%;
    width: 60%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    // padding-left: 20px;
    margin-right: 20px;
  }
  .block-top-button {
    height: 5%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .el-select .el-input__inner {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0;
    font-size: 22px;
  }
  .el-cascader .el-input__inner {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0;
    color: #ffffff;
    font-size: 22px;
  }
  .el-cascader .el-cascader__tags .el-tag {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0;
    color: #ffffff;
    font-size: 22px;
  }
}
</style>
